import { render, staticRenderFns } from "./Zahlungsdaten.vue?vue&type=template&id=12235122&scoped=true"
import script from "./Zahlungsdaten.vue?vue&type=script&lang=js"
export * from "./Zahlungsdaten.vue?vue&type=script&lang=js"
import style0 from "./Zahlungsdaten.vue?vue&type=style&index=0&id=12235122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12235122",
  null
  
)

export default component.exports